import {
  AUTHENTICATE,
  AUTHENTICATE_SUCCESS,
  AUTHENTICATE_FAIL,
  SET_PAYLOAD,
  LOGOUT
} from '../constants/auth';
import config from '../../config';

const initialState = {
  authenticated: false,
  user: null,
  authenticating: false,
  authenticateFail: null,
  payload: null
}

export default (state = initialState, action) => {
  switch (action.type) {
    case AUTHENTICATE:
      return {
        ...state,
        authenticating: true,
        authenticated: false,
        user: null,
        authenticateFail: null
      };
    case AUTHENTICATE_FAIL:
      return {
        ...state,
        authenticating: false,
        authenticated: false,
        user: null,
        authenticateFail: true
      };
    case AUTHENTICATE_SUCCESS:
      return {
        ...state,
        authenticating: false,
        authenticated: true,
        user: action.data,
        authenticateFail: null
      };
    case SET_PAYLOAD:
      return {
        ...state,
        payload: action.data
      };
    case LOGOUT:
      window.localStorage.removeItem('jwt');
      window.location.href = config.signoutURL;
      return null;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/auth.js